export default __webpack_public_path__ + "static/1626-272366b27c9453046450a30acc88ab9a.gif";